import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import _ from "lodash";
import Accordion from "react-bootstrap/Accordion";
import { io } from "socket.io-client";
import {
   calculateOODatetime,
   updateProjektStatus,
   handlephoneandemail,
   getAllFieldnames,
   httpPost,
   getStaticData,
   getKachelObject,
   teamsMessageFunctions,
   api,
   formatCurrency,
   evaluateRule,
   handleSP,
   handleNote,
   isJSON,
} from "./pureFunctions";

import Kachel from "./Kachel";

import SpeicherCheck from "./SpeicherCheck";
import TabMenu from "./TabMenu";
import LoadScreen from "./LoadScreen";
import MyTabs from "./MyTabs";
import FehlerMeldung from "./FehlerMeldung";
import Initialisierung from "./Initialisierung";
import DatenblattImmoSidebar from "./DatenblattImmoSidebar";
import DatenblattEigenSidebar from "./DatenblattEigenSidebar";
import Eskalationspause from "./Eskalationspause";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import AllgemeineBemerkung from "./AllgemeineBemerkung";
import NotizUbersicht from "./NotizUbersicht";
import DateiUbersicht from "./DateiUbersicht";
import ObjektMenu from "./ObjektMenu";

import { header, host, eskalationsLevel } from "./globalVariables";
import ExterneLink from "./ExterneLinks";
import Stapelverarbeitung from "./Stapelverarbeitung";
import OnlineStatus from "./OnlineStatus";
import DatenblattPDF from "./DatenblattPDF";
import EmailVersand from "./EmailVersand";
import Bearbeitungsanfrage from "./Bearbeitungsanfrage";
import { useWindowSize } from "./customHooks";
import { useContext } from "react";
import { useConfig } from "./ConfigContext";
import FotoManager from "./FotoManager";
import Medien from "./Medien";
import SocialMedia from "./SocialMedia";
import { useAuth } from "./AuthContext";
import DatenblattAushang from "./DatenblattAushang";
import { useM365Context } from "./m365Context";
import AIExpo from "./AIComponents/AIExpo";
import SharepointFileUpload from "./SharepointFileUpload";
import FotoUpload from "./FotoUpload";
import { useSearchParams } from "react-router";
import { getEstateData, saveEstateData } from "./networkFunctions";
import { AiHelper } from "./AIComponents/AiHelper";
import ImageGenerator from "./Tools/ImageGenerator";
import { AddKachel } from "./Settings/AddKachel";
import { AddStufe } from "./Settings/AddStufe";
import GalleryParent from "./DropBoxGalleryParent";

const bewertungscheckverantwortlicher = "CMollis";

const sonstigeObjektFeldnamen = ["dbin_a_o_b"];
const sonstigeAdressFeldnamen = ["KdNr"]; //Veranstaltungsdatum, Leadart

const onOfficeFelder = [
   { name: "objektnr_extern", onOffice: "objektnr_extern" },
   { name: "Id", onOffice: "Id" },
   { name: "status", onOffice: "status" },
   { name: "objektart", onOffice: "objektart" },
   { name: "benutzer", onOffice: "benutzer" },
   { name: "laengengrad", onOffice: "laengengrad" },
   { name: "breitengrad", onOffice: "breitengrad" },
];

const inAktivityTime = 60000 * 5;

export default function Datenblatt({
   postMsSharelink,
   postMsSharepointNewFolder,
   updateMsSharepointNewFolder,
   activeAccount,
}) {
   const { user, setUser } = useAuth();
   const config = useConfig();
   const [showAll, setShowAll] = useState(false);
   const [terminData, setTerminData] = useState();
   const [openMedia, setOpenMedia] = useState(false);
   const [backgroundRefresh, setBackgroundRefresh] = useState(false);
   const [newKachelNotify, setNewKachelNotify] = useState([]);
   const [options, setOptions] = useState({ kachelSort: "basic" });
   // const [estateId, setEstateId] = useState();
   const [searchParams] = useSearchParams();
   const estateId = searchParams.get("estateid");
   const [titleimageURL, setTitleImageURL] = useState();
   const [dbxData, setDbxData] = useState("");
   const [estateURL, setEstateURL] = useState();
   const [ownerURL, setOwnerURL] = useState();
   const [fieldconfiguration, setFieldConfiguration] = useState();
   const [basicdata, setBasicData] = useState();
   const [eskstatus, setEskStatus] = useState();
   const [kachelStatus, setKachelStatus] = useState({});
   const [notizen, setNotizen] = useState({});
   const [sharepointIDs, setSharepointIDs] = useState({});
   const [basicdata_alt, setBasicData_alt] = useState();
   const [eskstatus_alt, setEskStatus_alt] = useState();
   const [ownerData, setOwnerData] = useState({});
   const [speichercheck, setSpeicherCheck] = useState({ active: false });
   const [eskalationsPause, setEskalationsPause] = useState({
      datum: "",
      text: "",
   });
   const [projektstufe, setProjektstufe] = useState("");
   const [selectedkachel, setSelectedKachel] = useState();
   const [allKacheln, setAllKacheln] = useState();
   const [estatekacheln, setEstatekacheln] = useState();
   const [loading, setLoading] = useState("");
   const [userlist, setUserlist] = useState();
   const [userObjects, setUserObjects] = useState();
   const [errorMessage, setErrorMessage] = useState();
   const [onlineStatus, setOnlineStatus] = useState(false);
   const [sharepointObject, setSharepointObject] = useState();
   const [sharepointData, setSharepointData] = useState();
   const [sharepointFoldername, setSharepointFoldername] = useState();
   const [mailWarteschleife, setMailWarteschleife] = useState([]);
   const [loadingSP, setLoadingSP] = useState(false);
   const [kachelObject, setKachelObject] = useState();
   const [showAnfrage, setShowAnfrage] = useState(false);
   const [blockedField, setBlockedField] = useState({});
   const [currentElement, setCurrentElement] = useState({});
   const [lastLogin, setLastLogin] = useState(0);
   const [editLayout, setEditLayout] = useState(false);

   const { width } = useWindowSize();
   const socketRef = useRef();
   const { getSharepointData, getMS365User, postMsTeamsTeamMessage } = useM365Context();

   useEffect(() => {
      console.log(user);

      if (sharepointFoldername && activeAccount && !loadingSP) {
         loadSharepointData();
      }
   }, [activeAccount, sharepointFoldername]);

   async function loadSharepointData() {
      setLoadingSP(true);

      const driveData = await getSharepointData(sharepointFoldername, config.ms365.driveId)
         .then((data) => {
            let newSharePointObject = data.flatArray.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item }), {});
            /*  console.log("Sharepoint-Daten: ");
            console.log(newSharePointObject); */

            setSharepointObject(newSharePointObject);
            console.log(data.objectTree);

            setSharepointData(data.objectTree);
            return data;
         })
         .catch((err) => {
            console.error(err);
            setErrorMessage({
               error: "sharepoint",
               message: `<br/>Fehler beim Sharepointorder. Wurde er evtl. manuell verschoben oder manuell umbenannt?<br/>
               Wenn ja, bitte den Ordner wieder zu <strong>${sharepointFoldername}</strong> zurückbenennen und wenn gewünscht dann hier im CRM in den Objekteinstellungen den Ordnername ändern.`,
            });
         });

      setLoadingSP(false);
      return driveData;
   }

   useEffect(() => {
      console.log(user);

      if (estateId && user && userObjects && !socketRef.current) {
         let oldLogin = 0;
         try {
            oldLogin = JSON.parse(localStorage.getItem("lastLogin"))[estateId] ?? 0;
         } catch (error) {
            console.log(error);
         }

         try {
            getEstateData(estateId, ["dbxFolder", "dbxData"]).then((data) => {
               console.log(data);
               console.log(data);

               // setDbxData(Object.values(data)?.[0]);
               if (data.dbxData) {
                  setDbxData(data.dbxData);
               } else if (data.dbxFolder) {
                  setDbxData({ name: data.dbxFolder, foto: true, hdr: true });
               } else {
                  setDbxData(false);
               }
            });
         } catch (error) {
            console.log(error);
            setDbxData("Fehler beim Laden");
         }

         setLastLogin(new Date(oldLogin));

         // socketRef.current = socketIO.connect(host);
         socketRef.current = io(host, { withCredentials: true });

         socketRef.current.on("connect_error", (err) => {
            console.log("Auth-Fehler:", err.message); // "Sitzung abgelaufen" etc.
            // z.B. Login-Redirect oder Hinweis anzeigen
         });

         socketRef.current.on("requestActiveUser_" + estateId, (data) => {
            console.log(data);
            console.log(data.name);
            console.log(user.Vorname + " " + user.Nachname);

            if (data.name != user.Vorname + " " + user.Nachname) {
               handleBearbeitungsanfrage(data);
            }
         });

         socketRef.current.on("connect", () => {
            // console.log("connected: ");
            socketRef.current.emit("join-room", { roomName: estateId, userId: user.id });
         });
         socketRef.current.on("current-users", (msg) => {
            // console.log(socketRef.current.id);

            console.log("Nutzerupdate:", msg);
            setOnlineStatus(Object.values(msg).length > 1 ? msg : false);

            let blockedObjects = Object.keys(msg).reduce(
               (oldObj, item) =>
                  socketRef.current.id !== item && msg[item].isBlocked
                     ? { ...oldObj, [msg[item].element]: { user: userObjects[msg[item].userId] } }
                     : oldObj,
               {},
            );

            setBlockedField(blockedObjects);
         });

         socketRef.current.on("server-client", (msg) => {
            console.log(msg);

            let blockedObjects = Object.keys(msg).reduce(
               (oldObj, item) =>
                  socketRef.current.id !== item && msg[item].isBlocked
                     ? { ...oldObj, [msg[item].element]: { user: userObjects[msg[item].userId] } }
                     : oldObj,
               {},
            );

            if (!import.meta.env.PROD) {
               // Noch im Test, in Produktion nicht die Daten ändern
               Object.values(msg).forEach((item) => {
                  if (item.isChanged) {
                     setBasicData((prev) => ({ ...prev, [item.element]: item.value }));
                     setBasicData_alt((prev) => ({ ...prev, [item.element]: item.value }));
                     if (item.element === config.estate.sharepointIds) {
                        setSharepointIDs(item.value);
                     }
                  }
               });
            }

            console.log(blockedObjects);

            setBlockedField(blockedObjects);
         });
         socketRef.current.on("disconnect", () => {
            // console.log("disconnected");
            setOnlineStatus(false);
         });
      }

      return () => {
         socketRef.current?.removeAllListeners();
         socketRef.current?.disconnect();
         socketRef.current = null;

         if (estateId) {
            let newLogin;
            try {
               newLogin = JSON.parse(localStorage.getItem("lastLogin")) ?? {};
            } catch (error) {
               newLogin = {};
            }

            newLogin[estateId] = new Date();
            localStorage.setItem("lastLogin", JSON.stringify(newLogin));
         }
      };
   }, [estateId, user, userObjects]);

   function handleElementBlock(block, name, value) {
      if (block) {
         console.log("Block element: " + name);

         socketRef.current.emit("client-server", {
            room: estateId,
            message: {
               name: name,
               isBlocked: block,
               userId: user.id,
               isChanged: !block && value !== currentElement.value,
               value: value,
            },
         });
      } else {
         if (currentElement.element === name) {
            console.log("Free element: " + name);

            socketRef.current.emit("client-server", {
               room: estateId,
               message: {
                  name: name,
                  isBlocked: block,
                  userId: user.id,
                  isChanged: !block && value !== currentElement.value,
                  value: value,
               },
            });
         }
      }
      setCurrentElement(block ? { value: value, element: name } : {});
   }

   function requestActiveUser() {
      if (estateId && user && socketRef.current) {
         console.log("zugriff angef");

         socketRef.current.emit("requestActiveUser", {
            estateId: estateId,
            name: user.Vorname + " " + user.Nachname,
         });
      }
   }

   function handleBearbeitungsanfrage(data) {
      setShowAnfrage(data);
      // alert(data.name + " möchte das Objekt bearbeiten");
   }

   useEffect(() => {}, [estateId]);

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      // const url_id = params.get("estateid");
      const url_stufe = params.get("stufe");
      const url_kachel = params.get("kachel");

      url_stufe && setProjektstufe(url_stufe);
      url_kachel && setSelectedKachel(url_kachel);
      // setEstateId(url_id);

      if (estateId) {
         fetchEstateBasicData(estateId);
         let lastSeen = Date.now();
         let timeOutTimerId;

         document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
               lastSeen = Date.now();

               timeOutTimerId = setTimeout(() => {
                  if (socketRef.current) {
                     socketRef.current.disconnect();
                     setCurrentElement({});
                  }
               }, inAktivityTime);
            } else {
               const timeAway = Date.now() - lastSeen;
               if (timeOutTimerId) {
                  clearTimeout(timeOutTimerId);
               }
               if (timeAway > inAktivityTime) {
                  setBackgroundRefresh(true);
                  setTimeout(() => {
                     setBackgroundRefresh(false);
                  }, 4000);
                  fetchEstateBasicData(estateId);

                  if (socketRef.current) {
                     socketRef.current.connect();
                  }
               }
            }
         });
      }
   }, [estateId]);

   async function fetchEstateBasicData(url_id) {
      let owner_ids;
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      setAllKacheln(newestatekacheln);
      setFieldConfiguration(newfieldConfiguration);
      setUserObjects(cleanUserData.userObject);
      setUserlist(cleanUserData.userList);
      setEstatekacheln(newestatekacheln);

      setKachelObject(() => getKachelObject(newestatekacheln));
      let allfieldobjects = getAllFieldnames(newestatekacheln);
      let allfields;
      await api
         .post("/api/getOoLink", { id: url_id, resourcetype: "estate" }, header)
         .then((estateooLink) => {
            setEstateURL(estateooLink.data.url);
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            setErrorMessage({
               error: "onOffice",
               message: JSON.stringify(err.response.data, null, 1),
            });
         });
      let fieldList = [
         ...[...allfieldobjects, ...onOfficeFelder]
            .filter(
               (item) =>
                  item.onOffice && item.module !== "address" && !(item.company && item.company !== config.company),
            )
            .map((item) => item.onOffice),
         ...Object.values(config.estate),
      ];

      let estateBasicData = await api
         .post(
            "/api/getEstateBasicData",
            [
               {
                  id: url_id,
                  datarequest: fieldList,
               },
            ],
            header,
         )
         .catch((err) => {
            console.log(err);

            setErrorMessage({
               error: "onOffice",
               message:
                  "<strong>Fehler beim Laden der onOffice-Objektdaten</strong> <br/> <br/>" +
                  JSON.stringify(err.response.data, null, 1),
            });
         });
      console.log("estateBasicData:");
      console.log(estateBasicData);

      /* ------ EKtermin laden ----------- */
      const responseTermine = await api
         .post(
            "/api/getactivity",
            {
               parameters: {
                  estateid: url_id,
                  filter: {
                     Aktionstyp: [{ op: "IN", val: Object.values(config.datenBlatt.termine).map((item) => item.name) }], //"Einkaufstermin neu"
                  },
                  data: ["Datum", "Aktionstyp", "created", "Bemerkung", "Benutzer_bearb", "Nr", "Benutzer"],
               },
            },
            header,
         )
         .then((data) => {
            console.log("Termine:");
            console.log(data);

            return data.data.filter((item) => !item.elements.Bemerkung.includes("ACHTUNG! TERMIN GELÖSCHT!"));
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            setErrorMessage({
               error: "onOffice",
               message: "Fehler beim Lesen von Terminen <br/>" + JSON.stringify(err.response.data, null, 1),
            });
         });

      console.log(responseTermine);

      let currentEkTermine, currentFtTermine;
      let currentTermine = {};
      if (responseTermine.length) {
         Object.keys(config.datenBlatt.termine).forEach((terminKey) => {
            currentTermine[terminKey] = responseTermine.filter(
               (item) => item.elements.Aktionstyp === config.datenBlatt.termine[terminKey].name,
            );
         });
         currentEkTermine = responseTermine.filter(
            (item) => item.elements.Aktionstyp === config.datenBlatt.termine.einkaufstermin.name,
         );
         currentFtTermine = responseTermine.filter((item) => item.elements.Aktionstyp === "Fototermin");

         try {
            setTerminData(JSON.stringify(responseTermine));
         } catch {
            console.log(responseTermine);
         }
      }
      console.log(currentEkTermine);

      setTitleImageURL(estateBasicData.data.url);
      setSharepointFoldername(estateBasicData.data[config.estate.ordnerName]);
      // console.log(estateBasicData.data);
      let ooJSONObject;
      try {
         ooJSONObject = estateBasicData.data[config.estate.JSONFeldname]
            ? JSON.parse(estateBasicData.data[config.estate.JSONFeldname])
            : {};
      } catch (error) {
         setErrorMessage({
            error: "onOffice",
            message: "<h2>Fehler im JSON Object</h2>" + estateBasicData.data[config.estate.JSONFeldname],
         });
      }

      if (estateBasicData.data[config.estate.notiz]) {
         setNotizen(JSON.parse(estateBasicData.data[config.estate.notiz]));
      }
      if (estateBasicData.data[config.estate.mailWarteschleife]) {
         setMailWarteschleife(JSON.parse(estateBasicData.data[config.estate.mailWarteschleife]));
      }
      if (estateBasicData.data[config.estate.sharepointIds]) {
         setSharepointIDs(JSON.parse(estateBasicData.data[config.estate.sharepointIds]));
      }

      if (estateBasicData.data[config.estate.eskalationspause]) {
         setEskalationsPause(JSON.parse(estateBasicData.data[config.estate.eskalationspause]));
      }
      /* if (estateBasicData.data[config.estate.inaktiveProjektstufen]) {
         estateBasicData.data[config.estate.inaktiveProjektstufen] = JSON.parse(
            estateBasicData.data[config.estate.inaktiveProjektstufen],
         );
      } */

      const mergeddata = {
         ...ooJSONObject,
         ...estateBasicData.data,
      };

      allfields = [
         ...allfieldobjects,
         ...onOfficeFelder,
         ...Object.values(config.estate).map((item) => ({ name: item, onOffice: item })),
      ]
         .filter((item) => item.module !== "address")
         .reduce(
            (obj, item) => ({
               ...obj,
               [item.name]: mergeddata[item.name] ? mergeddata[item.name] : "",
            }),
            {},
         );

      const sonstigeFelder = sonstigeObjektFeldnamen.reduce(
         (obj, item) => ({
            ...obj,
            [item]: mergeddata[item] ? mergeddata[item] : "",
         }),
         {},
      );

      allfields = { ...allfields, ...sonstigeFelder };

      if (ooJSONObject.quelle) {
         allfields[config.estate.quelle] = ooJSONObject.quelle;
      }
      console.log(ooJSONObject);
      let ekDatum = currentEkTermine?.[0]?.elements?.Datum;
      if (ekDatum) allfields.einkaufstermin_am = ekDatum;
      let ftDatum =
         currentFtTermine?.length > 0 ? currentFtTermine?.[currentFtTermine.length - 1]?.elements?.Datum : false;
      if (ftDatum) {
         allfields[config.estate.fototermin] = ftDatum;
         allfields.ft_termin = currentFtTermine.map((item) => item.elements.Bemerkung).join(`
█████████████████████████████████████████████
            `);
      }

      console.log("Alle Daten: ");

      console.log(allfields);

      // const respEstateOwnerId = await api.post(host + "/api/postEstateOwnerId", [url_id], header);
      const respEstateOwnerId = await httpPost(host + "/api/postEstateOwnerId", [url_id], setLoading, setErrorMessage);
      owner_ids = respEstateOwnerId.data[url_id];
      // setOwnerId(owner_ids[0])
      if (owner_ids.length) {
         allfields.noowner = false;

         let addressFieldList = [
            ...allfieldobjects
               .filter(
                  (item) =>
                     item.onOffice && item.module === "address" && !(item.company && item.company !== config.company),
               )
               .map((item) => item.onOffice),
            ...sonstigeAdressFeldnamen,
            ...Object.values(config.address),
         ];

         /* let addressFieldList =
            config.company === "baur"
               ? fullAddressFieldList
               : fullAddressFieldList.filter((item) => !item.includes("ind_")); */

         const respSpecificAddress = await httpPost(
            host + "/api/postSpecificAddress",
            {
               id: owner_ids[0],
               data: addressFieldList,
            },
            setLoading,
            setErrorMessage,
         );

         let ownerresponse = { ...respSpecificAddress.data };
         let ownerkeys = Object.keys(ownerresponse);

         if (
            ownerresponse[config.address.veranstaltungsdatum] &&
            allfields["ind_3324_Feld_ObjIndividualCategoryFields301"] === "0000-00-00"
         ) {
            allfields["ind_3324_Feld_ObjIndividualCategoryFields301"] =
               ownerresponse[config.address.veranstaltungsdatum];
         }

         let phonekey = ownerkeys.filter((element) => element.includes("phone_"));
         let phoneprivatekey = ownerkeys.filter((element) => element.includes("phoneprivate_"));
         let phonebusinesskey = ownerkeys.filter((element) => element.includes("phonebusiness_"));
         let mobilekey = ownerkeys.filter((element) => element.includes("mobile_"));
         let emailkey = ownerkeys.filter((element) => element.includes("email_"));
         let emailprivatekey = ownerkeys.filter((element) => element.includes("emailprivate_"));
         let emailbusinesskey = ownerkeys.filter((element) => element.includes("emailbusiness_"));
         ownerresponse.phone = phonekey.length ? ownerresponse[phonekey[0]] : "";
         ownerresponse.phone_private = phoneprivatekey.length ? ownerresponse[phoneprivatekey[0]] : "";
         ownerresponse.phone_business = phonebusinesskey.length ? ownerresponse[phonebusinesskey[0]] : "";
         ownerresponse.mobile = mobilekey.length ? ownerresponse[mobilekey[0]] : "";
         ownerresponse.email = emailkey.length ? ownerresponse[emailkey[0]] : "";
         ownerresponse.email_private = emailprivatekey.length ? ownerresponse[emailprivatekey[0]] : "";
         ownerresponse.email_business = emailbusinesskey.length ? ownerresponse[emailbusinesskey[0]] : "";
         /* ownerresponse.email2 =
                      emailkey.length > 1 ? ownerresponse[emailkey[1]] : ""; */
         // console.log(ownerresponse);

         ownerresponse.ownerid = ownerresponse.id;
         delete ownerresponse.id;
         allfields = { ...allfields, ...ownerresponse };
         initializeState(newestatekacheln, allfields, estateBasicData);
         setOwnerData(ownerresponse);

         // console.log(owner_ids);

         await api
            .post("/api/getOoLink", { id: owner_ids[0], resourcetype: "address" }, header)
            .then((ownerOoLink) => {
               setOwnerURL(ownerOoLink.data.url);
            })
            .catch((err) => {
               console.log(JSON.stringify(err.response.data, null, 1));
               setErrorMessage({
                  error: "onOffice",
                  message:
                     "Fehler beim onOffice-Link des Eigentümers <br/>" + JSON.stringify(err.response.data, null, 1),
               });

               if (err.response.data.length && err.response.data[0].error.code === "ECONNRESET") {
               }
            });
      } else {
         setOwnerData({});
         allfields.noowner = true;
         initializeState(newestatekacheln, allfields, estateBasicData);
      }
   }

   function kachelAbschliessen(abschliessen, myKachelId) {
      console.log(myKachelId);
      if (abschliessen) {
         changeEskStatus(myKachelId, "normalname", user.Name, false, false);
      } else {
         changeEskStatus(myKachelId, "normalname", "", false, false);
      }
   }

   function initializeState(myestatekacheln, allfields, estateBasicData) {
      let oldStatus = estateBasicData.data[config.estate.status]
         ? JSON.parse(estateBasicData.data[config.estate.status])
         : {};
      let newStatus = structuredClone(oldStatus);
      console.log(myestatekacheln);

      //----------------------------------------

      Object.keys(myestatekacheln).forEach((psItem) => {
         // console.log(psItem);
         const alldata = { ...oldStatus, ...allfields };

         if (
            evaluateRule(alldata, myestatekacheln[psItem].filter, showAll) &&
            newStatus["projekt_status_" + psItem] === undefined
         ) {
            console.log("neue Stufe: " + psItem);
            newStatus["projekt_status_" + psItem] = 0;

            myestatekacheln[psItem].kachel.forEach((kItem) => {
               if (
                  evaluateRule(alldata, kItem.filter, showAll) &&
                  newStatus["kachel_status_" + kItem.kachelId] === undefined
               ) {
                  if (newStatus["kachel_status_" + kItem.kachelId] === undefined) {
                     if (kItem.optional) {
                        newStatus["kachel_status_" + kItem.kachelId] = 10;
                     } else {
                        console.log("Neue Kachel: " + kItem.kachelId);
                        setNewKachelNotify((prev) => [...prev, kItem.kachelId]);

                        const maxEsk = new Date();
                        const standardEsk = new Date();
                        standardEsk.setDate(standardEsk.getDate() + parseInt(kItem.standardEskalationsfrist));
                        maxEsk.setDate(maxEsk.getDate() + parseInt(kItem.maxEskalationsfrist));
                        newStatus["kachel_status_" + kItem.kachelId] = 0;

                        newStatus["kachel_max_eskalation_" + kItem.kachelId] = kItem.pflichtEskalation ? maxEsk : false;
                        newStatus["kachel_eskalation_" + kItem.kachelId] = kItem.pflichtEskalation
                           ? standardEsk
                           : false;
                     }
                  }
               }
            });
         }
      });

      setBasicData(allfields);
      setBasicData_alt(allfields);
      setEskStatus(newStatus);
      setEskStatus_alt(newStatus);
   }

   function filterEstateKacheln(myestatekacheln, filterData, filterEskstatus) {
      /* Filtert erstmal die Projektstufen und dann die Kacheln nach den in dependency hinterlegten Parametern */
      let alldata = { ...filterEskstatus, ...filterData };
      let newEskStatus = structuredClone(filterEskstatus);

      const filteredObject = Object.keys(myestatekacheln).reduce((obj, item) => {
         let projektfilterresult = evaluateRule(alldata, myestatekacheln[item].filter, showAll);

         if (projektfilterresult && newEskStatus["projekt_status_" + item] === undefined) {
            console.log("neue Stufe: " + item);
            newEskStatus["projekt_status_" + item] = 0;
         }

         if (projektfilterresult) {
            return {
               ...obj,
               [item]: {
                  ...myestatekacheln[item],
                  kachel: myestatekacheln[item].kachel.filter((kItem) => {
                     const statusKey = "kachel_status_" + kItem.kachelId;
                     const hasStatus = newEskStatus[statusKey] !== undefined && newEskStatus[statusKey] !== null;

                     let kachelfilterresult = evaluateRule(alldata, kItem.filter, showAll);

                     if (!kachelfilterresult && hasStatus) {
                        kachelfilterresult = true;
                     }

                     if (kachelfilterresult && !hasStatus) {
                        if (kItem.optional) {
                           newEskStatus["kachel_status_" + kItem.kachelId] = 10;
                        } else {
                           console.log("Neue Kachel: " + kItem.kachelId);
                           setNewKachelNotify((prev) => [...prev, kItem.kachelId]);

                           const maxEsk = new Date();
                           const standardEsk = new Date();
                           standardEsk.setDate(standardEsk.getDate() + parseInt(kItem.standardEskalationsfrist));
                           maxEsk.setDate(maxEsk.getDate() + parseInt(kItem.maxEskalationsfrist));
                           newEskStatus[statusKey] = 0;

                           newEskStatus["kachel_max_eskalation_" + kItem.kachelId] = kItem.pflichtEskalation
                              ? maxEsk
                              : false;
                           newEskStatus["kachel_eskalation_" + kItem.kachelId] = kItem.pflichtEskalation
                              ? standardEsk
                              : false;
                        }
                     }

                     return kachelfilterresult;
                  }),
               },
            };
         } else {
            return obj;
         }
      }, {});

      console.log(newEskStatus);

      console.log(filteredObject);

      Object.keys(filteredObject).forEach((projekt_key) => {
         if (!filteredObject[projekt_key].kachel.length) {
            newEskStatus["projekt_status_" + projekt_key] = 4;
         }
      });

      return [filteredObject, newEskStatus];
   }

   async function postNotesOrSP(estateId, ooFieldname, newmessage) {
      await api
         .post(
            "/api/sendCommentsandNotes",
            {
               estateId,
               ooFieldname,
               newmessage,
            },
            header,
         )
         .then((data) => {
            return data;
         })
         .catch((err) => {
            console.log(err);
            setErrorMessage({
               error: "onOffice",
               message: "Fehler beim Senden von Notizen/Dateien <br/>" + JSON.stringify(err.response.data, null, 1),
            });
            setLoading("error");
         });
   }

   async function sendCommentsandNotes(type, kachelid, message, index) {
      console.log(message);
      setLoading("loading");
      let newmessage;
      let ooFieldname;
      let newBasicData = structuredClone(basicdata);
      if (type === "note") {
         newmessage = handleNote(notizen, kachelid, message, index);
         ooFieldname = config.estate.notiz;
      } else if (type === "sharepoint") {
         newmessage = handleSP(sharepointIDs, kachelid, message, index);
         ooFieldname = config.estate.sharepointIds;
      }

      console.log(index);

      console.log(newmessage);

      saveEstateData({ kachelNotes: { [kachelid]: newmessage[kachelid] } }, estateId);
      await postNotesOrSP(estateId, ooFieldname, newmessage);

      if (type === "note") {
         setNotizen(newmessage);
      } else if (type === "sharepoint") {
         setSharepointIDs(newmessage);
      }

      /* newBasicData[ooFieldname] = JSON.stringify(newmessage);

      setBasicData(newBasicData); */

      setLoading("success");
      setTimeout(() => {
         setLoading(false);
      }, 1100);

      return newmessage;
   }

   async function updateNotes(newmessage, changedNoteData) {
      let ooFieldname = config.estate.notiz;
      setLoading("loading");
      saveEstateData({ kachelNotes: changedNoteData }, estateId);

      await api
         .post(
            "/api/sendCommentsandNotes",
            {
               estateId,
               ooFieldname,
               newmessage,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            setNotizen(newmessage);
            let newBasicData = structuredClone(basicdata);
            newBasicData[ooFieldname] = JSON.stringify(newmessage);
            setBasicData(newBasicData);

            setLoading("success");
            setTimeout(() => {
               setLoading(false);
            }, 1100);
         })
         .catch((err) => {
            console.log(err);
            setLoading("error");
            setErrorMessage({
               error: "onOffice",
               message: "Fehler beim Aktualisieren von Notizen <br/>" + JSON.stringify(err.response.data, null, 1),
            });
         });
   }

   async function createOOTask(tasktype, taskdata) {
      setLoading("loading");
      await api
         .post("/api/getActionType", {}, header)
         .then((data) => {
            console.log(data);
            setLoading("success");
            setTimeout(() => {
               setLoading(false);
            }, 1100);
         })
         .catch((err) => {
            console.log(err);
            setLoading("error");
            setErrorMessage({
               error: "onOffice",
               message:
                  "Fehler beim Auslesen der Action-Type oO-Aufgabe <br/>" + JSON.stringify(err.response.data, null, 1),
            });
         });

      let parameters;
      let dataFieldname;
      if (tasktype === "wiedervorlage") {
         dataFieldname = "bewAbs";
         parameters = {
            data: {
               Beginnt_am: calculateOODatetime(basicdata.bewDat),
               Betreff: "Wiedervorlage " + basicdata[config.estate.objektBezeichnung],
               Verantwortung: userObjects[basicdata.benutzer].Name,
               Status: 4,
               Prio: 3,
               Aufgabe: basicdata.bewHinweis,
               Art: 541, //Akquise Wiedervorlage
            },
            relatedAddressId: basicdata.ownerid,
            relatedEstateId: parseInt(estateId),
         };
      } else if (tasktype === "eskalationsänderung") {
         parameters = {
            data: taskdata,
            relatedAddressId: basicdata.ownerid,
            relatedEstateId: parseInt(estateId),
         };
      } else if (tasktype === "bewertungsabsage") {
         dataFieldname = "beaAbs";
         parameters = {
            data: {
               Beginnt_am: calculateOODatetime(new Date()),
               Betreff: "Absagencheck " + basicdata[config.estate.objektBezeichnung],
               Verantwortung: bewertungscheckverantwortlicher,
               Status: 4,
               Prio: 3,
               Aufgabe:
                  basicdata.beaHinweis +
                  ` ${import.meta.env.VITE_MY_DOMAIN}/datenblatt?estateid=${estateId}&stufe=bewertungsergebnis&kachel=bewertungsergebnisAbsagesprüfung`,
               Art: 617, //Absagencheck
            },
            relatedAddressId: basicdata.ownerid,
            relatedEstateId: parseInt(estateId),
         };
      }
      console.log(parameters);

      await api
         .post("/api/createTask", parameters, header)
         .then((data) => {
            console.log(data);
            if (dataFieldname) {
               changeData(dataFieldname, "" + new Date().toLocaleString() + " von " + user.Name, "single");
            }

            setLoading("success");
            setTimeout(() => {
               setLoading(false);
            }, 1100);
         })
         .catch((err) => {
            console.log(err);
            setErrorMessage({
               error: "onOffice",
               message: "Fehler beim Erstellen der oO-Aufgabe <br/>" + JSON.stringify(err.response.data, null, 1),
            });
            setLoading("error");
         });
   }

   async function teamsChannelNotification(teamsMessage) {
      setLoading("loading");
      const teamId = import.meta.env.PROD ? (config.ms365.prodTeam ?? teamsMessage.teamId) : config.ms365.devTeam;
      const channelId = import.meta.env.PROD ? teamsMessage.channelId : config.ms365.devChannel;

      let newmessage =
         teamsMessageFunctions[teamsMessage.name] &&
         teamsMessageFunctions[teamsMessage.name]({
            basicdata: basicdata,
            objektBezeichung: config.estate.objektBezeichnung,
            estateId: estateId,
            users: userObjects,
            ownerData: ownerData,
            fieldconfiguration: fieldconfiguration,
            kachelId: selectedkachel,
            ordnerName: config.estate.ordnerName,
         });

      let newmessage2;
      if (teamsMessage.content) {
         newmessage2 = teamsMessage.content;
         console.log(teamsMessage);

         console.log(teamsMessage.contentData);

         teamsMessage.contentData.forEach((dataString, index) => {
            newmessage2 = newmessage2.replace("$" + dataString + "$", basicdata[dataString]);
         });
      }
      console.log(newmessage2);

      console.log(newmessage);

      let mentions = [];

      let taggedUsers = []; //["Jonathan Mischke"];
      if (teamsMessage?.taggedUsers) {
         for (const [index, item] of teamsMessage?.taggedUsers?.entries()) {
            const taggedUser = userObjects?.[basicdata[item]];
            if (taggedUser) {
               const result = `${taggedUser.Vorname[0].toLowerCase()}.${taggedUser.Nachname.toLowerCase()}`;

               const msUserData = await getMS365User(result);

               mentions.push({
                  id: index,
                  mentionText: msUserData.displayName,
                  mentioned: {
                     user: { id: msUserData.id, displayName: msUserData.displayName, userIdentityType: "aadUser" },
                  },
               });
            }
         }
      }
      let messageData = {
         body: {
            contentType: "html",
            content:
               (teamsMessage.content ? newmessage2 : newmessage) +
               mentions.map((item, index) => `<at id=${index}>${item.mentionText}</at>`).join(" "),
         },
         mentions: mentions,
      };
      console.log(messageData);

      try {
         await postMsTeamsTeamMessage(teamId, channelId, messageData);
      } catch (err) {
         console.error(err);
         alert(`Nachricht konnte nicht gesendet werden.
            ${JSON.stringify(err)}`);
      }

      setTimeout(() => {
         setLoading(false);
         if (teamsMessage.respField) {
            changeData(teamsMessage.respField, new Date().toLocaleString() + " von " + user.Name, "single");
         }
      }, 1000);
   }

   function handleAutomations(company, newData, oldData) {
      console.log(company);
      console.log(newData);

      if (company === "bender") {
         /*energieausweistyp ind_2602_Feld_ObjVerwaltung204 wenn Energieausweis notwendig --> Ja und Liegt Energieausweis vor --> Nein 
         --> Feld Energieausweis (ind_Schl_5307) --> "Energieausweis in Erstellung"  */
         if (newData["ead_not"] === "Ja" && newData["ead_vorh"] === "Nein") {
            // newData["energieausweistyp"] = "liegtZurBesichtigungVor";
            // newData["ind_2602_Feld_ObjVerwaltung204"] = "ind_Schl_5307";
         }
         /* 
         Energieausweis notwendig --> Nein 
         --> Feld Energieausweis (ind_Schl_5307) --> Es besteht keine Energieausweispflicht
         */
         if (newData["ead_not"] === "Nein") {
            // newData["energieausweistyp"] = "es besteht keine Pflicht!";
         }
      } else if (company === "baur") {
         if (newData["ead_not"] === "Nein") {
            newData["energieausweistyp"] = "es besteht keine Pflicht!";
         } else if (newData["ead_vorh"] === "Nein") {
            newData["energieausweistyp"] = "liegtZurBesichtigungVor";
         }
      }
   }

   async function sendData({
      currentkachelid = false,
      postData = basicdata,
      postNotes = notizen,
      postEskData = eskstatus,
      closeKachel = false,
   }) {
      setLoading("loading");
      const newdata = structuredClone(postData);
      let newNotizen = structuredClone(postNotes);

      let newFirstEskstatus = structuredClone(postEskData);
      if (newdata.einkaufstermin_am) {
         const EKTDatum = new Date(newdata.einkaufstermin_am);
         if (EKTDatum > new Date()) {
            const maxDat = new Date(newdata.einkaufstermin_am);
            const stdDat = new Date(newdata.einkaufstermin_am);
            maxDat.setDate(EKTDatum.getDate() + 7);
            newFirstEskstatus["kachel_max_eskalation_bewertungsbestellung"] = maxDat;
            stdDat.setDate(EKTDatum.getDate() + 2);
            newFirstEskstatus["kachel_eskalation_bewertungsbestellung"] = stdDat;
         }
      }
      if (newdata.bb_dat) {
         const DeadlineDatum = new Date(newdata.bb_dat);
         if (DeadlineDatum > new Date()) {
            const maxDat = new Date(newdata.bb_dat);
            const stdDat = new Date(newdata.bb_dat);
            maxDat.setDate(DeadlineDatum.getDate() + 7);
            newFirstEskstatus["kachel_max_eskalation_bewertungsergebnis"] = maxDat;
            stdDat.setDate(DeadlineDatum.getDate() + 2);
            newFirstEskstatus["kachel_eskalation_bewertungsergebnis"] = stdDat;
         }
      }

      if (
         newdata[config.estate.notarTerminDatum] &&
         newdata[config.estate.notarTerminDatum] !== basicdata_alt[config.estate.notarTerminDatum]
      ) {
         try {
            const notarTerminDatum = new Date(newdata[config.estate.notarTerminDatum]);
            newFirstEskstatus["kachel_eskalation_KaufpreisProvisionsPruefung"] = notarTerminDatum;
            newFirstEskstatus["kachel_max_eskalation_KaufpreisProvisionsPruefung"] = notarTerminDatum;

            newFirstEskstatus["kachel_eskalation_NotarNachbereitung"] = notarTerminDatum;
            newFirstEskstatus["kachel_max_eskalation_NotarNachbereitung"] = notarTerminDatum;
         } catch (error) {
            console.log(error);
         }
      }
      if (newdata.kark_zhlDat && newdata.kark_zhlDat !== basicdata_alt.kark_zhlDat) {
         try {
            newFirstEskstatus["kachel_eskalation_RechnungsstellungKaeufer"] = new Date(newdata.kark_zhlDat);
            newFirstEskstatus["kachel_max_eskalation_RechnungsstellungKaeufer"] = new Date(newdata.kark_zhlDat);
         } catch (error) {
            console.log(error);
         }
      }
      if (newdata.karvk_zhlDat && newdata.karvk_zhlDat !== basicdata_alt.karvk_zhlDat) {
         try {
            newFirstEskstatus["kachel_eskalation_RechnungsstellungVerkaeufer"] = new Date(newdata.karvk_zhlDat);
            newFirstEskstatus["kachel_max_eskalation_RechnungsstellungVerkaeufer"] = new Date(newdata.karvk_zhlDat);
         } catch (error) {
            console.log(error);
         }
      }

      if (
         newFirstEskstatus["kachel_status_vorankuendigungbackoffice"] === 4 &&
         eskstatus_alt["kachel_status_vorankuendigungbackoffice"] !== 4
      ) {
         newFirstEskstatus = initProjektstufenEskalation(newFirstEskstatus, "datenblatt", 7);
      }

      if (
         newFirstEskstatus["kachel_status_vollmachten"] === 4 &&
         eskstatus_alt["kachel_status_vollmachten"] !== 4 &&
         !newdata[config.estate.vollmachtsDatumZeit]
      ) {
         console.log("Vollmachten abgeschlossen...");
         newdata[config.estate.vollmachtsDatumZeit] = new Date();
      }
      if (
         newFirstEskstatus["kachel_status_uebergabe"] === 4 &&
         eskstatus_alt["kachel_status_uebergabe"] !== 4 &&
         newdata[config.estate.verkaufsStatus] === "in_akquise"
      ) {
         console.log("Verkaufsstatus auf in Vorlauf offline geändert...");
         newdata[config.estate.verkaufsStatus] = config.select.statusVorlaufOffline;
      }
      handleAutomations(config.company, newdata, basicdata_alt);
      console.log(newdata);

      if (config.company === "baur" && newdata["beaErgeb"] === "Ja") {
         console.log("status auf bewertung gescheitert");

         newdata[config.estate.verkaufsStatus] = config.select.statusBewertungGescheitert;
         console.log(config.select.statusBewertungGescheitert);
      }

      console.log(newdata);

      try {
         const benutzerKuerzel = userObjects[newdata.benutzer].Kuerzel;

         newdata[config.estate.objektBezeichnung] =
            benutzerKuerzel +
            " " +
            fieldconfiguration.estate.objektart.permittedvalues[newdata.objektart] +
            " " +
            newdata.Name +
            " " +
            newdata.ort +
            " " +
            newdata.strasse +
            " " +
            newdata.hausnummer +
            " " +
            (newdata[config.estate.objektBezeichnungszusatz] ? newdata[config.estate.objektBezeichnungszusatz] : "") +
            " " +
            newdata.objektnr_extern;
      } catch (error) {
         console.log(error);
      }

      if (
         basicdata_alt[config.estate.ordnerName] &&
         newdata[config.estate.ordnerName] != basicdata_alt[config.estate.ordnerName]
      ) {
         newdata[config.estate.ordnerName] = await changeSharepointFolder(newdata[config.estate.ordnerName]);
      }

      /* ---------- Check ob Statusänderung durchgeführt werden soll ------------ */
      if (false) {
         if (newdata[config.estate.isTestObjekt] === "1") {
            // Wenn Testobjekt
            if (
               (newdata["bmweitererverlauf"] === "Auftrag kommt" &&
                  newFirstEskstatus["projekt_status_bewertungsergebnis"] === 4) ||
               newdata["dbin_a_o_b"] === "Auftrag"
            ) {
               // newdata[config.estate.verkaufsStatus] = config.select.statusVorlaufOnline; // in Vorlauf
               newdata[config.estate.verkaufsStatus] = "ind_Schl_5007"; // Jonathans Teststatus in Vorlauf
            } else {
               // newdata[config.estate.verkaufsStatus] = "in_akquise"; // in Bewertung
               newdata[config.estate.verkaufsStatus] = "ind_Schl_4939"; // Jonathans Teststatus in Bewertung
            }
         }
      }
      /* -------------------------------- */
      let aktiveEskDaten = {};

      let aktivekachelkeys = Object.keys(newFirstEskstatus)
         .filter((item) => item.includes("kachel_status_"))
         .map((item) => item.split("kachel_status_")[1]);

      console.log(aktivekachelkeys);

      aktivekachelkeys.forEach((item) => {
         if (newFirstEskstatus["kachel_eskalation_" + item]) {
            if (newFirstEskstatus["kachel_status_" + item] < eskalationsLevel) {
               aktiveEskDaten[item] = newFirstEskstatus["kachel_eskalation_" + item];
            }
         }
      });

      aktiveEskDaten = Object.keys(aktiveEskDaten).length ? aktiveEskDaten : "";

      console.log(aktiveEskDaten);

      /* ------------------------------------ */

      let [firstfilteredkacheln, newSecondEskstatus] = filterEstateKacheln(
         estatekacheln,
         newdata,
         updateProjektStatus(newFirstEskstatus, allKacheln),
      );

      let [filteredkacheln, neweskstatus] = filterEstateKacheln(
         estatekacheln,
         newdata,
         updateProjektStatus(newSecondEskstatus, firstfilteredkacheln),
      );

      /* Kachelstatus auf begonnen setzen, wenn noch nicht begonnen oder abgeschlossen */
      if (currentkachelid && neweskstatus["kachel_status_" + currentkachelid] < 1) {
         neweskstatus["kachel_status_" + currentkachelid] = 1;
      }

      if (
         newdata[config.estate.besichtigungsTerminierungsDatum] &&
         new Date(newdata[config.estate.besichtigungsTerminierungsDatum]).getTime() !==
            new Date(basicdata_alt[config.estate.besichtigungsTerminierungsDatum]).getTime()
      ) {
         const DeadlineDatum = new Date(newdata[config.estate.besichtigungsTerminierungsDatum]);
         const maxDat = new Date(DeadlineDatum);
         const stdDat = new Date(DeadlineDatum);
         maxDat.setDate(DeadlineDatum.getDate() + 21);
         neweskstatus["kachel_max_eskalation_besichtigung"] = maxDat;
         stdDat.setDate(DeadlineDatum.getDate() + 0);
         neweskstatus["kachel_eskalation_besichtigung"] = stdDat;
         neweskstatus["kachel_status_besichtigung"] = 1;
         newdata["bes_verlauf"] = newdata["bes_verlauf"] + DeadlineDatum.toLocaleString() + "\n";
      }

      if (
         newdata[config.estate.fotoTerminAb] &&
         new Date(newdata[config.estate.fotoTerminAb]).getTime() !==
            new Date(basicdata_alt[config.estate.fotoTerminAb]).getTime()
      ) {
         console.log(newdata[config.estate.fotoTerminAb]);
         console.log(basicdata_alt[config.estate.fotoTerminAb]);

         const DeadlineDatum = new Date(newdata[config.estate.fotoTerminAb]);
         const maxDat = new Date(DeadlineDatum);
         const stdDat = new Date(DeadlineDatum);
         maxDat.setDate(DeadlineDatum.getDate() + 7);
         neweskstatus["kachel_max_eskalation_expo_bilder_erstellen"] = maxDat;
         stdDat.setDate(DeadlineDatum.getDate() + 0);
         neweskstatus["kachel_eskalation_expo_bilder_erstellen"] = stdDat;
         neweskstatus["kachel_status_expo_bilder_erstellen"] = 1;
      }

      /* ---------------------------------------- */

      //VA-Timer
      if (
         (newdata["bmweitererverlauf"] === "Auftrag kommt" || newdata["dbin_a_o_b"] === "Auftrag") &&
         !newdata[config.estate.vorankundigungsdatum]
      ) {
         console.log("Vorankündigung gesetzt");

         newdata[config.estate.vorankundigungsdatum] = new Date();
         newdata[config.estate.auftragsdatum] = new Date();
         console.log(newdata[config.estate.vorankundigungsdatum]);
      }

      if (newdata["bb_fibj"] !== basicdata_alt["bb_fibj"]) {
         newdata["bb_note"] =
            newdata["bb_note"] +
            "\n\nBei der Vergleichswertberechnung wurde ein gemitteltes, fiktives Baujahr von " +
            newdata["bb_fibj"] +
            " verwendet, um den baulichen Zustand und durchgeführte Modernisierungen rechnerisch abzubilden.";

         let bewertungsBestellungNotiz = {
            text: newdata["bb_note"],
            type: { Expose: { active: true }, expose: { active: true } },
            timestamp: new Date().toISOString(),
            user: user.Name,
            active: true,
         };

         if (newNotizen["bewertungsbestellung"]) {
            newNotizen["bewertungsbestellung"].push(bewertungsBestellungNotiz);
         } else {
            newNotizen["bewertungsbestellung"] = [bewertungsBestellungNotiz];
         }
         console.log(newNotizen);

         // newdata[config.estate.notiz] = JSON.stringify(newNotizen);
      }

      try {
         if (
            newdata["abbv_gultigDat"] &&
            new Date(newdata["abbv_gultigDat"]).toISOString() !==
               new Date(basicdata_alt["abbv_gultigDat"] || 0).toISOString()
         ) {
            let brandversicherungNotiz = {
               text: `Die Brandversicherung ist/war bis zum **${new Date(newdata["abbv_gultigDat"]).toLocaleString()}** gültig. Bitte prüfen, falls abgelaufen!`,
               type: { Notar: { active: true } },
               timestamp: new Date().toISOString(),
               user: user.Name,
               active: true,
            };

            if (newNotizen["brandversicherung"]) {
               newNotizen["brandversicherung"].push(brandversicherungNotiz);
            } else {
               newNotizen["brandversicherung"] = [brandversicherungNotiz];
            }
         }
      } catch (error) {
         console.log(basicdata_alt["abbv_gultigDat"]);
         console.log(error);
      }

      if (newdata["vam_txt"]) {
         let textsnipped;
         if (newdata?.objektart === "grundstueck") {
            textsnipped = `\n\nBitte beachten Sie, dass es sich bei den Informationen zu diesem Grundstück um eine Vorabinformation handelt. Da wir diese Informationen teilweise noch ungeprüft vom Auftraggeber übernommen haben, kann es zum offiziellen Verkaufsstart noch zu Korrekturen oder auch Preisanpassungen kommen.
        \n\nUnter Umständen können Grundstücke, die sich im Status der Vorankündigung befinden, noch nicht besichtigt werden. Sie können sich aber bereits exklusiv für die ersten Besichtigungen vormerken lassen oder das endgültige Exposé zum Grundstück vorbestellen. Soweit möglich beantworten wir Ihre eventuellen Fragen natürlich gerne bereits vorab.`;
         } else {
            textsnipped = `\n\nBitte beachten Sie, dass es sich bei den Informationen zu dieser Immobilie um eine Vorabinformation handelt. Da wir diese Informationen teilweise noch ungeprüft vom Auftraggeber übernommen haben, kann es zum offiziellen Verkaufsstart noch zu Korrekturen oder auch Preisanpassungen kommen.
        \n\nUnter Umständen können Immobilien, die sich im Status der Vorankündigung befinden, noch nicht besichtigt werden. Sie können sich aber bereits exklusiv für die ersten Besichtigungen vormerken lassen oder das endgültige Exposé zur Immobilie vorbestellen. Soweit möglich beantworten wir Ihre eventuellen Fragen natürlich gerne bereits vorab.`;
         }
         newdata["freitext03"] = newdata["vam_txt"] + textsnipped;
      }

      if (config.estate.preisVerlauf && newdata["kaufpreis"] && newdata["kaufpreis"] != basicdata_alt["kaufpreis"]) {
         if (newdata[config.estate.preisVerlauf]) {
            newdata[config.estate.preisVerlauf] +=
               `\n${new Date().toLocaleDateString()}: ${formatCurrency(parseFloat(newdata.kaufpreis))}`;
         } else {
            newdata[config.estate.preisVerlauf] =
               `${new Date().toLocaleDateString()}: ${formatCurrency(parseFloat(newdata.kaufpreis))}`;
         }
      }
      //Datum Fototermin
      if (newdata[config.estate.fototermin] && !newFirstEskstatus["kachel_eskalation_expo_grundriss"]) {
         let fotodate = new Date(newdata[config.estate.fototermin]);
         let grundrissdate = fotodate.setDate(fotodate.getDate() + 3);
         neweskstatus["kachel_eskalation_expo_grundriss"] = grundrissdate;
         neweskstatus["kachel_eskalation_expo_text"] = grundrissdate;
         neweskstatus["kachel_eskalation_expo_bilder_bearbeiten"] = grundrissdate;
         //"kachel_max_eskalation_expo_grundriss"
      }

      // Notartextfeld

      /* oONotarDatumsfeld oONotarTextfeld */

      /*  if (newdata[oONotarTextfeld]) {
         newdata[oONotarDatumsfeld] = new Date(newdata[oONotarTextfeld]);

      } */

      //Automatische Notizerstellung
      if (newdata["dbhz_notHw"] && newdata["dbhz_notHw"] != basicdata_alt["dbhz_notHw"]) {
         console.log("Sendet Notizen");
         let heizNotiz = {
            text: newdata["dbhz_notHw"],
            type: { Expose: { active: true }, Notar: { active: true } },
            timestamp: new Date().toISOString(),
            user: user.Name,
            active: true,
         };

         if (newNotizen["heiz_sani_ausstattung"]) {
            newNotizen["heiz_sani_ausstattung"].push(heizNotiz);
         } else {
            newNotizen["heiz_sani_ausstattung"] = [heizNotiz];
         }
      }

      let oOProjektstufenstatus = Object.keys(neweskstatus)
         .filter((item) => item.includes("projekt_status_"))
         .reduce(
            (oldObj, item) => ({
               ...oldObj,
               [item.split("projekt_status_")[1]]: neweskstatus[item],
            }),
            {},
         );

      console.log(oOProjektstufenstatus);

      let oOKachelstatus = Object.keys(neweskstatus)
         .filter((item) => item.includes("kachel_status_"))
         .reduce(
            (oldObj, item) => ({
               ...oldObj,
               [item.split("kachel_status_")[1]]: neweskstatus[item],
            }),
            {},
         );

      let oOPMFreigabe = Object.keys(neweskstatus)
         .filter((item) => item.includes("pm_dat_"))
         .reduce(
            (oldObj, item) => ({
               ...oldObj,
               [item.split("pm_dat_")[1]]: neweskstatus[item],
            }),
            {},
         );

      if (
         newdata["ea_vorhanden"] === "liegt zur Besichtigung vor" &&
         basicdata_alt["ea_vorhanden"] !== "liegt zur Besichtigung vor"
      ) {
         newdata["energieausweistyp"] = "liegtZurBesichtigungVor";
      }

      const flatarray = getAllFieldnames(estatekacheln);

      const sonstigeFelder = sonstigeObjektFeldnamen.reduce((obj, item) => ({ ...obj, [item]: newdata[item] }), {});

      const json_array = flatarray
         .filter((item) => item.module !== "address" && !item.onOffice)
         .reduce(
            (obj, item) => ({
               ...obj,
               [item.name]: newdata[item.name] ? newdata[item.name] : "",
            }),
            sonstigeFelder,
         );

      const oOJSONData = JSON.stringify(json_array, null, 1);

      newdata[config.estate.notiz] = JSON.stringify(newNotizen);
      newdata[config.estate.sharepointIds] = JSON.stringify(sharepointIDs);

      let oOObjectValue = [
         ...flatarray,
         ...onOfficeFelder,
         ...Object.values(config.estate).map((item) => ({ name: item, onOffice: item })),
      ]
         .filter(
            (item) => item.module !== "address" && item.onOffice && !(item.company && item.company !== config.company),
         )
         .reduce((obj, item) => ({ ...obj, [item.name]: newdata[item.name] }), {});
      oOObjectValue = {
         ...oOObjectValue,
         [config.estate.JSONFeldname]: oOJSONData,
         freitext03: newdata["freitext03"],
         [config.estate.nutzer]: user.Name,
         [config.estate.eskalationsdaten]: Object.keys(aktiveEskDaten).length
            ? JSON.stringify(aktiveEskDaten, null, 1)
            : "",
         [[config.estate.projektstatus]]: JSON.stringify(oOProjektstufenstatus, null, 1),
         [config.estate.kachelstatus]: JSON.stringify(oOKachelstatus, null, 1),
         [config.estate.pmfreigabe]: JSON.stringify(oOPMFreigabe, null, 1),
         [config.estate.status]: JSON.stringify(neweskstatus, null, 1),
      };

      console.log(oOObjectValue);

      await api
         .post(
            "/api/updateEstateDatenblatt",
            [
               {
                  estateId,
                  oOObjectValue,
               },
            ],
            header,
         )
         .then((data) => {
            console.log(data);
            setBasicData(newdata);
            setBasicData_alt(newdata);
            setEskStatus(neweskstatus);
            setEskStatus_alt(neweskstatus);
            setNotizen(newNotizen);
            setLoading("success");
            setTimeout(() => {
               setLoading(false);
            }, 1100);
         })
         .catch((err) => {
            console.log(err);
            setLoading("error");
            setErrorMessage({
               error: "onOffice",
               message: "Fehler beim Speichern der Objektdaten <br/>" + JSON.stringify(err.response.data, null, 1),
            });
         });

      if (true && basicdata.ownerid) {
         setLoading("loading");
         const flatarray = getAllFieldnames(estatekacheln);

         const oo_fieldname_array = flatarray
            .filter(
               (item) =>
                  item.module === "address" && item.onOffice && !(item.company && item.company !== config.company),
            )
            .reduce(
               (obj, item) => [
                  ...obj,
                  {
                     onOffice: item.name,
                     value: newdata[item.name],
                     oldvalue: basicdata_alt[item.name],
                  },
               ],
               [],
            );
         // phone,mobile,email
         let udpads = oo_fieldname_array.reduce((arr, item) => {
            let newval;
            let newkey;
            if (
               item.onOffice === "mobile" ||
               item.onOffice === "phone" ||
               item.onOffice === "phone_private" ||
               item.onOffice === "phone_business" ||
               item.onOffice === "email" ||
               item.onOffice === "email_business" ||
               item.onOffice === "email_private"
            ) {
               newkey = item.onOffice;
               newval = handlephoneandemail(item);
               if (!newval) return { ...arr };
            } else {
               newval = item.value;
               newkey = item.onOffice;
            }
            return { ...arr, [newkey]: newval };
         }, {});

         // Wenn im Rückfragedatum nichts eingetragen ist, wer eingeben, sonst wirft es einen Fehler 0000-00-00

         if (udpads[config.address.rueckfrageDatum] === null) {
            console.log("ALARM");

            udpads[config.address.rueckfrageDatum] = "0000-00-00";
         }
         if (udpads.ind_3090_Feld_adressen97 === null) {
            console.log("ALARM");
            delete udpads["ind_3090_Feld_adressen97"];
         }

         console.log(udpads);
         await api
            .post(
               "/api/updateAddress",
               {
                  id: basicdata.ownerid,
                  updateData: udpads,
               },
               header,
            )
            .then((data) => {
               console.log(data);
               setLoading("success");
               setTimeout(() => {
                  setLoading(false);
               }, 1100);
            })
            .catch((err) => {
               console.log(err);
               setLoading("error");
               setErrorMessage({
                  error: "onOffice",
                  message:
                     "Fehler beim Speichern der Eigentümerdaten <br/>" + JSON.stringify(err.response.data, null, 1),
               });
            });
      }

      if (closeKachel) {
         setSelectedKachel("");
      }
   }

   async function sendSpecificData(myfieldname, mydata) {
      let oOFieldname;
      if (myfieldname === "eskalationspause") {
         oOFieldname = config.estate.eskalationspause;
      }
      oOFieldname &&
         (await httpPost(
            host + "/api/updateSpecificEstateField",
            {
               estateId,
               oOdata: { [oOFieldname]: JSON.stringify(mydata), [config.estate.nutzer]: user.Name },
            },
            setLoading,
            setErrorMessage,
         ));
   }

   function changeEskStatus(myKachelId, myName, myValue, myPmFreigabe, myAdminFreigabe) {
      let cloneKachelStatus = structuredClone(kachelStatus);
      let newEskStatus = structuredClone(eskstatus);
      let freigabenValue = 0;

      if (!cloneKachelStatus[myKachelId])
         cloneKachelStatus[myKachelId] = {
            status: "",
            person: "",
            admin: "",
            datum: "",
            limit: "",
         };
      switch (myName) {
         case "normalname":
            newEskStatus["kachelabschluss_von_" + myKachelId] = myValue;
            cloneKachelStatus[myKachelId].person = myValue;
            if (newEskStatus["kachel_status_" + myKachelId] < 4 || !myValue) {
               freigabenValue = !myAdminFreigabe && !myPmFreigabe ? 4 : 2;
               newEskStatus["kachel_status_" + myKachelId] = myValue ? freigabenValue : 1;
               cloneKachelStatus[myKachelId].status = myValue ? freigabenValue : 1;
               newEskStatus["kachelabschluss_admin_von_" + myKachelId] = "";
               newEskStatus["globalAdmin_" + myKachelId] = "";
            }
            break;
         case "adminname":
            freigabenValue = 1 + (myAdminFreigabe ? 1 : 0) + (myPmFreigabe ? 1 : 0);
            newEskStatus["globalAdmin_" + myKachelId] = myValue;
            cloneKachelStatus[myKachelId].admin = myValue;
            newEskStatus["kachel_status_" + myKachelId] = myValue ? 4 : freigabenValue;
            cloneKachelStatus[myKachelId].status = myValue ? 4 : freigabenValue;
            break;
         case "pmname":
            freigabenValue = 4 - (myAdminFreigabe ? 1 : 0);
            newEskStatus["kachelabschluss_admin_von_" + myKachelId] = myValue;
            cloneKachelStatus[myKachelId].pm = myValue;
            newEskStatus["kachel_status_" + myKachelId] = myValue ? freigabenValue : 2;
            cloneKachelStatus[myKachelId].status = myValue ? freigabenValue : 2;
            newEskStatus["globalAdmin_" + myKachelId] = "";
            break;
         case "eskdatum":
            newEskStatus["kachel_eskalation_" + myKachelId] = myValue;
            cloneKachelStatus[myKachelId].datum = myValue;
            break;
         case "maxeskdatum":
            newEskStatus["kachel_max_eskalation_" + myKachelId] = myValue;
            cloneKachelStatus[myKachelId].limit = myValue;
            break;
         default:
            break;
      }
      console.log(newEskStatus["kachel_status_" + myKachelId]);

      if (newEskStatus["kachel_status_" + myKachelId] != eskstatus["kachel_status_" + myKachelId]) {
         console.log("Kachelabschluss geändert");
         if (newEskStatus["kachel_status_" + myKachelId] === 2) {
            newEskStatus["pm_dat_" + myKachelId] = new Date();
         }

         let [newKacheln, newEskStatus2] = filterEstateKacheln(
            estatekacheln,
            basicdata,
            updateProjektStatus(newEskStatus, allKacheln),
         );
         newEskStatus = newEskStatus2;
      }

      setKachelStatus(cloneKachelStatus);
      setEskStatus(newEskStatus);
   }

   function disableProjektstufen(myProjektstufe) {
      let newEskStatus = structuredClone(eskstatus);
      const disable = newEskStatus["projekt_status_" + myProjektstufe] < 9;
      console.log(newEskStatus);

      estatekacheln[myProjektstufe].kachel.forEach((itemkachel) => {
         const myKachelStatus = newEskStatus["kachel_status_" + itemkachel.kachelId];
         if (myKachelStatus !== undefined && myKachelStatus !== null) {
            newEskStatus["kachel_status_" + itemkachel.kachelId] += disable ? 10 : -10;
         } else {
            newEskStatus["kachel_status_" + itemkachel.kachelId] = disable ? 10 : 1;
         }
      });
      const myProjektStatus = newEskStatus["projekt_status_" + myProjektstufe];
      if (myProjektStatus !== undefined && myProjektStatus !== null) {
         newEskStatus["projekt_status_" + myProjektstufe] += disable ? 10 : -10;
      } else {
         newEskStatus["projekt_status_" + myProjektstufe] = disable ? 10 : 1;
      }

      setEskStatus(newEskStatus);
      console.log(newEskStatus);
   }

   async function removeKachel(projektstufe, heading, mylayoutdata) {
      let newEskStatus = structuredClone(eskstatus);
      newEskStatus["kachel_status_" + mylayoutdata.kachelId] = 10;

      await sendData({ postEskData: newEskStatus });

      setSelectedKachel("");
   }

   function initProjektstufenEskalation(funEskStatus, funStufe, funDelta) {
      console.log("initalize datenblatt eskalationen");

      let newEskStatus = structuredClone(funEskStatus);
      console.log(newEskStatus);
      let newEskDatum = new Date(new Date().getTime() + funDelta * 24 * 60 * 60 * 1000);

      allKacheln[funStufe].kachel
         .filter(
            (kItem) =>
               typeof newEskStatus["kachel_status_" + kItem.kachelId] !== "undefined" &&
               newEskStatus["kachel_status_" + kItem.kachelId] < 10,
         )
         .forEach((kachel) => {
            newEskStatus["kachel_eskalation_" + kachel.kachelId] = newEskDatum;
            newEskStatus["kachel_max_eskalation_" + kachel.kachelId] = newEskDatum * 2;
         });
      console.log(newEskStatus);

      return newEskStatus;
   }

   function changeData(name, value, type) {
      if (eskstatus["kachel_status_" + selectedkachel] === 4) {
         const newEskStatus = structuredClone(eskstatus);

         newEskStatus["kachelabschluss_von_" + selectedkachel] = "";
         newEskStatus["kachel_status_" + selectedkachel] = 1;
         if (newEskStatus["kachelabschluss_admin_von_" + selectedkachel])
            newEskStatus["kachelabschluss_admin_von_" + selectedkachel] = "";
         if (newEskStatus["globalAdmin_" + selectedkachel]) newEskStatus["globalAdmin_" + selectedkachel] = "";

         setEskStatus(newEskStatus);
      }

      if (type === "single") setBasicData((prev) => ({ ...prev, [name]: value }));
      else if (type === "currency") setBasicData((prev) => ({ ...prev, [name]: value === undefined ? 0 : value }));
      else if (type === "multi") {
         const valuearray = [...basicdata[name]];
         const valueindex = valuearray.indexOf(value);
         if (valueindex > -1) {
            valuearray.splice(valueindex, 1);
         } else {
            valuearray.push(value);
         }
         setBasicData((prev) => ({ ...prev, [name]: valuearray }));
      } else if (type === "init") {
         if (value === "Bewertung") {
            let initialBewertungsStatus;
            if (config.company === "baur") initialBewertungsStatus = "in_akquise";
            if (config.company === "bender") initialBewertungsStatus = "ind_Schl_3265";
            setBasicData((prev) => ({
               ...prev,
               [config.estate.verkaufsStatus]: initialBewertungsStatus,
               status: "2",
               [name]: value,
            })); //inaktiv in Bewertung
         } else if (value === "Auftrag") {
            setBasicData((prev) => ({
               ...prev,
               [config.estate.verkaufsStatus]: config.select.statusVorlaufOffline,
               status: "1",
               [name]: value,
            })); //aktiv in Vorankündigung
         } else {
            setBasicData((prev) => ({ ...prev, [name]: value }));
         }
      }
   }

   function resetData() {
      setBasicData(basicdata_alt);
      setEskStatus(eskstatus_alt);
   }

   async function initializeObject(addFolder) {
      if (basicdata.objektnr_extern) {
         setLoading("loading");
         const newsharepointfoldername = basicdata.objektnr_extern + "_" + basicdata.Name;
         let initialFolderResponse;
         if (addFolder === "sharepoint") {
            initialFolderResponse = await postMsSharepointNewFolder(newsharepointfoldername, config.ms365.driveId);
         } else {
            initialFolderResponse = { name: "kein Sharepoint" };
         }

         const newBasicData = structuredClone(basicdata);
         newBasicData[config.estate.ordnerName] =
            initialFolderResponse && initialFolderResponse.name ? initialFolderResponse.name : "";
         console.log(initialFolderResponse);

         newBasicData[config.estate.sharepointFolderId] =
            initialFolderResponse && initialFolderResponse.id ? initialFolderResponse.id : "";

         await sendData({ postData: newBasicData });
         setBasicData(newBasicData);
         setBasicData_alt(newBasicData);
         setLoading("success");
         return true;
      }
   }

   async function changeSharepointFolder(newFolderName) {
      console.log(newFolderName);
      console.log(basicdata[config.estate.sharepointFolderId]);

      const spRenameResponse = await updateMsSharepointNewFolder(
         basicdata[config.estate.sharepointFolderId],
         newFolderName,
         config.ms365.driveId,
      );
      console.log(spRenameResponse);
      if (spRenameResponse.error) {
         return basicdata_alt[config.estate.ordnerName];
      } else {
         return newFolderName;
      }
   }

   async function saveSharepoint() {
      setSharepointFoldername(basicdata.objektnr_extern + "_" + basicdata.Name);
   }

   useEffect(() => {
      window.addEventListener("beforeunload", alertUser);
      return () => {
         window.removeEventListener("beforeunload", alertUser);
      };
   }, [basicdata, basicdata_alt, eskstatus, eskstatus_alt]);

   function checkSpeichern(e, type) {
      console.log(eskstatus);

      if (!_.isEqual(basicdata, basicdata_alt) || !_.isEqual(eskstatus, eskstatus_alt)) {
         setSpeicherCheck({ active: true, type: type, name: e });
      } else {
         type === "accordion" && setSelectedKachel(e);
         if (type === "tab") {
            setProjektstufe(e);
            setSelectedKachel("");
         }
      }
   }

   const alertUser = useCallback(
      (e) => {
         if (!_.isEqual(basicdata, basicdata_alt) || !_.isEqual(eskstatus, eskstatus_alt)) {
            console.log(basicdata);
            console.log(basicdata_alt);
            console.log(eskstatus);
            console.log(eskstatus_alt);

            setSpeicherCheck({ active: true });
            e.preventDefault();
            e.returnValue = "";
         } else {
            console.log("Keine ungespeicherten Änderungen vorhanden.");
         }
      },
      [basicdata, basicdata_alt, eskstatus, eskstatus_alt],
   );

   function editMultipleKachel(myDatenAnfordung, myEskDaten, mySelectedKacheln) {
      console.log(myDatenAnfordung);
      console.log(mySelectedKacheln);

      const newData = structuredClone(basicdata);
      const newEskData = structuredClone(eskstatus);

      Object.keys(mySelectedKacheln)
         .filter((item) => mySelectedKacheln[item])
         .forEach((kachelkey) => {
            Object.keys(myDatenAnfordung)
               .filter((item) => myDatenAnfordung[item])
               .forEach((datumkey) => {
                  newData[mySelectedKacheln[kachelkey] + "_" + datumkey] = myDatenAnfordung[datumkey];
               });
            if (myEskDaten["kachel_max_eskalation"]) {
               newEskData["kachel_max_eskalation_" + kachelkey] = myEskDaten["kachel_max_eskalation"];
            }
            if (myEskDaten["kachel_eskalation"]) {
               newEskData["kachel_eskalation_" + kachelkey] =
                  new Date(newEskData["kachel_max_eskalation_" + kachelkey]) < new Date(myEskDaten["kachel_eskalation"])
                     ? newEskData["kachel_max_eskalation_" + kachelkey]
                     : myEskDaten["kachel_eskalation"];
            }
         });

      console.log(newData);

      setBasicData(newData);
      setEskStatus(newEskData);
   }

   return (
      <div key={estateId}>
         {/*  <Button
            onClick={async () => {
               //  let abc = await getMS365User("j.mischke");
               //console.log(abc);
               await api.get("/api/getKacheln").then((data) => {
                  console.log(data);

                  return data.data;
               });
               await api.get("/api/getDBKacheln").then((data) => {
                  console.log(data);

                  return data.data;
               });
            }}
         >
            testbutton
         </Button> */}
         {openMedia && dbxData && (
            <GalleryParent
               folderName={dbxData.name}
               setOpenMedia={setOpenMedia}
               allowRename={basicdata?.ind_3302_Feld_ObjIndividualCategoryFields292 !== "1"}
            />
         )}
         {backgroundRefresh && (
            <Alert style={{ position: "absolute", margin: "40px", bottom: 0, right: 0 }}>
               <h2 className="m-2">Tab war inaktiv, neue Daten wurden geladen.</h2>
            </Alert>
         )}
         {showAnfrage && <Bearbeitungsanfrage showAnfrage={showAnfrage} setShowAnfrage={setShowAnfrage} />}
         {basicdata && (
            <title>{(onlineStatus ? "🔴" : "") + basicdata.objektnr_extern + (onlineStatus ? "🔴" : "")}</title>
         )}
         {errorMessage ? (
            <FehlerMeldung errorMessage={errorMessage} setErrorMessage={setErrorMessage} />
         ) : (
            <>
               <OnlineStatus
                  onlineStatus={onlineStatus}
                  userObjects={userObjects}
                  requestActiveUser={requestActiveUser}
               />
               <LoadScreen loading={loading} setLoading={setLoading} />
               <SpeicherCheck
                  speichercheck={speichercheck}
                  setSpeicherCheck={setSpeicherCheck}
                  sendData={sendData}
                  verwerfen={resetData}
                  loading={loading}
                  setSelectedKachel={setSelectedKachel}
                  setProjektstufe={setProjektstufe}
               />
               {newKachelNotify.length > 0 && kachelObject && (
                  <div className="notification">
                     <div>
                        <h3>Neue Kacheln:</h3>{" "}
                        <ul>
                           {newKachelNotify.map((item) => (
                              <li> {kachelObject[item].heading}</li>
                           ))}
                        </ul>
                        <Button variant="success" onClick={() => setNewKachelNotify([])}>
                           Okay
                        </Button>
                     </div>
                  </div>
               )}
               <div className="fullframe">
                  <div className="datenblatt-sidebar" open={width > 990 ? true : false}>
                     <div>
                        {basicdata && notizen && (
                           <NotizUbersicht
                              basicdata={basicdata}
                              estateId={estateId}
                              user={user}
                              notizen={notizen}
                              loading={loading}
                              lastLogin={lastLogin}
                              updateNotes={updateNotes}
                              handleElementBlock={handleElementBlock}
                              currentElement={currentElement}
                              blockedField={blockedField}
                           />
                        )}

                        {basicdata && (
                           <EmailVersand
                              estateId={estateId}
                              postMsSharelink={postMsSharelink}
                              sharepointIDs={sharepointIDs}
                              sharepointObject={sharepointObject}
                              user={user}
                              userObjects={userObjects}
                              setMailWarteschleife={setMailWarteschleife}
                              mailWarteschleife={mailWarteschleife}
                              teamsChannelNotification={teamsChannelNotification}
                              spLink={
                                 config?.ms365?.sharepointUrl +
                                 "/Immobilien/" +
                                 (basicdata[config.estate.ordnerName] ? basicdata[config.estate.ordnerName] : "")
                              }
                           />
                        )}
                        {basicdata && (
                           <DateiUbersicht
                              data={basicdata}
                              dbxData={dbxData}
                              sharepointIDs={sharepointIDs}
                              sharepointObject={sharepointObject}
                              estateId={estateId}
                              ownerData={ownerData}
                              spLink={
                                 config?.ms365?.sharepointUrl +
                                 "/Immobilien/" +
                                 (basicdata[config.estate.ordnerName] ? basicdata[config.estate.ordnerName] : "")
                              }
                           />
                        )}
                        {basicdata && (
                           <ExterneLink
                              basicdata={basicdata}
                              estateId={estateId}
                              ownerData={ownerData}
                              dbxData={dbxData}
                           />
                        )}
                        <DatenblattImmoSidebar
                           titleimageURL={titleimageURL}
                           estateURL={estateURL}
                           basicdata={basicdata}
                           fieldconfiguration={fieldconfiguration}
                           eskstatus={eskstatus}
                           userObjects={userObjects}
                           setOpenMedia={setOpenMedia}
                           dbxData={dbxData}
                        />
                        {basicdata && <DatenblattEigenSidebar ownerData={ownerData} ownerURL={ownerURL} />}

                        {basicdata && (
                           <AllgemeineBemerkung
                              data={basicdata}
                              user={user}
                              fieldName={config.estate.bemerkung}
                              changeData={changeData}
                              loading={loading}
                              sendData={sendData}
                           />
                        )}
                        {basicdata && (
                           <Eskalationspause
                              eskalationsPause={eskalationsPause}
                              setEskalationsPause={setEskalationsPause}
                              sendSpecificData={sendSpecificData}
                              loading={loading}
                           />
                        )}
                     </div>
                  </div>

                  {basicdata && (
                     <div className="datenblatt-content">
                        <div
                           style={{
                              position: "relative",
                              display: "flex",
                              flexDirection: "row",
                              // flexWrap: "wrap",
                              justifyContent: "space-between",
                              marginBottom: 6,
                              alignItems: "center",
                           }}
                        >
                           {basicdata[config.estate.objektBezeichnung] && (
                              <h2
                                 className="datenblatt-heading"
                                 // title={terminData}
                                 // style={{ maxWidth: "calc(100% - 440px)" }}
                              >
                                 {basicdata[config.estate.objektBezeichnung].slice(0, -5)}
                                 {" - "}
                                 <strong>{basicdata.objektnr_extern}</strong>{" "}
                              </h2>
                           )}
                           <div
                              style={{
                                 
                                 // overflow: "auto",
                                 // width: "fit-content",
                                 
                              }}
                           >
                              <div
                              style={{
                                 borderRadius: 10,
                                 overflow: "hidden",
                                 width: "fit-content",
                                 border: "solid 2px #ddd",
                                 display: "flex",
                                 flexDirection: "row",
                              }}
                           >
                              <AiHelper allKacheln={allKacheln} basicdata={{ ...basicdata, ...eskstatus }} />
                              <ImageGenerator
                                 fieldconfiguration={fieldconfiguration}
                                 basicdata={{ ...basicdata, ...eskstatus }}
                                 userObjects={userObjects}
                              />
                              {
                                 <FotoUpload
                                    sharepointFileData={{
                                       driveId: config.ms365.driveId,
                                       parentId: basicdata[[config.estate.sharepointFolderId]],
                                    }}
                                 />
                              }
                              {true && (
                                 <SharepointFileUpload
                                    sharepointData={sharepointData}
                                    sharepointFileData={{
                                       driveId: config.ms365.driveId,
                                       parentId: basicdata[[config.estate.sharepointFolderId]],
                                    }}
                                 />
                              )}
                              {[
                                 "FBaur",
                                 "JonathanMischke",
                                 "ADorner",
                                 "DSauter",
                                 "BBaur",
                                 "LWidmann",
                                 "DLinkh",
                                 "DHoffmann",
                                 "NGolonka",
                              ].includes(user.Name) && (
                                 <AIExpo
                                    dbxData={dbxData}
                                    estateId={estateId}
                                    data={basicdata}
                                    kacheln={estatekacheln}
                                    eskstatus={eskstatus}
                                    fieldconfiguration={fieldconfiguration}
                                    user={user}
                                 />
                              )}
                              {/* {basicdata && (
                           <div style={{ position: "relative" }}>
                              <a
                                 target="_blank"
                                 href={"/uebergabeformular?estateId=" + estateId}
                                 onClick={() => {
                                    // createAushang();
                                 }}
                                 className="custom-button"
                                 style={{
                                    position: "absolute",
                                    width: "56px",
                                    right: "180px",
                                    zIndex: 0,
                                 }}
                                 title="Aushang runterladen"
                              >
                                 <img src={"./img/flyer.webp"} />
                              </a>
                           </div>
                        )} */}
                              {basicdata && (
                                 <DatenblattAushang
                                    titleimageURL={titleimageURL}
                                    bemerkungsfeld={config.estate.bemerkung}
                                    ownerData={ownerData}
                                    basicdata={basicdata}
                                    estatekacheln={allKacheln}
                                    fieldconfiguration={fieldconfiguration}
                                    allKacheln={allKacheln}
                                    userObjects={userObjects}
                                 />
                              )}
                              {basicdata && (
                                 <DatenblattPDF
                                    titleimageURL={titleimageURL}
                                    bemerkungsfeld={config.estate.bemerkung}
                                    ownerData={ownerData}
                                    basicdata={basicdata}
                                    estatekacheln={allKacheln}
                                    allKacheln={allKacheln}
                                 />
                              )}
                              {basicdata && (
                                 <ObjektMenu
                                    basicdata={basicdata}
                                    setBasicData={setBasicData}
                                    eskstatus={eskstatus}
                                    setEskStatus={setEskStatus}
                                    changeData={changeData}
                                    sendData={sendData}
                                    loading={loading}
                                    user={user}
                                    userlist={userlist}
                                    userObjects={userObjects}
                                    estatekacheln={estatekacheln}
                                    fieldconfiguration={fieldconfiguration}
                                    disableProjektstufen={disableProjektstufen}
                                 />
                              )}
                           </div>
                           </div>
                        </div>

                        {basicdata.energieausweistyp === "liegtZurBesichtigungVor" && (
                           <Alert variant="danger">
                              <strong>Wichtig!</strong> Besichtigungen dürfen noch nicht durchgeführt werden, weil noch
                              kein Energieausweis vorhanden ist.
                           </Alert>
                        )}
                        {basicdata[config.estate.bemerkung] && (
                           <h2 className="warnhinweis">{basicdata[config.estate.bemerkung]}</h2>
                        )}

                        {!sharepointFoldername ? (
                           <>
                              <Initialisierung
                                 sharepointFoldername={sharepointFoldername}
                                 activeAccount={activeAccount}
                                 initializeObject={initializeObject}
                                 data={basicdata}
                                 saveSharepoint={saveSharepoint}
                                 changeData={changeData}
                                 loading={loading}
                              />
                           </>
                        ) : (
                           <>
                              {eskstatus && basicdata && (
                                 <MyTabs
                                    eskstatus={eskstatus}
                                    datenblattkacheln={Object.fromEntries(
                                       Object.entries(allKacheln).filter(
                                          ([key, pItem]) => eskstatus["projekt_status_" + key] < 9,
                                       ),
                                    )}
                                    projektstufe={projektstufe}
                                    setSelectedKachel={setSelectedKachel}
                                    checkSpeichern={checkSpeichern}
                                    basicdata={basicdata}
                                 />
                              )}

                              {projektstufe && allKacheln && projektstufe === "aufbereitung" && (
                                 <Stapelverarbeitung
                                    user={user}
                                    userlist={userlist}
                                    editMultipleKachel={editMultipleKachel}
                                    sendData={sendData}
                                    resetData={resetData}
                                    datenblattkacheln={allKacheln}
                                    projektstufe={projektstufe}
                                    eskstatus={eskstatus}
                                 />
                              )}

                              {config.company === "baur" && projektstufe && allKacheln && (
                                 <>
                                    {projektstufe === "expoerstellung" && (
                                       <SocialMedia basicdata={basicdata} userObjects={userObjects} />
                                    )}
                                    {projektstufe === "fotografie" && (
                                       <FotoManager
                                          user={user}
                                          dbxData={dbxData}
                                          setDbxData={setDbxData}
                                          userlist={userlist}
                                          editMultipleKachel={editMultipleKachel}
                                          sendData={sendData}
                                          allKacheln={allKacheln}
                                          resetData={resetData}
                                          basicdata={basicdata}
                                          estateId={estateId}
                                          userObjects={userObjects}
                                          projektstufe={projektstufe}
                                          eskstatus={eskstatus}
                                          ownerData={ownerData}
                                       />
                                    )}
                                 </>
                              )}
                              {projektstufe && allKacheln && (
                                 <>
                                    <Accordion
                                       defaultActiveKey={""}
                                       className="mb-3"
                                       activeKey={selectedkachel}
                                       onSelect={(e) => checkSpeichern(e, "accordion")}
                                    >
                                       {allKacheln[projektstufe]?.kachel
                                          ?.filter((kItem) => {
                                             return eskstatus["kachel_status_" + kItem.kachelId] < 9;
                                             // return true
                                          })
                                          .sort((kachelA, kachelB) => {
                                             if (options.kachelSort === "basic") {
                                                if (kachelA.position > kachelB.position) return 1;
                                                else if (kachelA.position < kachelB.position) return -1;
                                                else return 0;
                                             } else if (options.kachelSort === "status") {
                                                if (
                                                   eskstatus["kachel_status_" + kachelA.kachelId] <
                                                   eskstatus["kachel_status_" + kachelB.kachelId]
                                                )
                                                   return -1;
                                                if (
                                                   eskstatus["kachel_status_" + kachelA.kachelId] >
                                                   eskstatus["kachel_status_" + kachelB.kachelId]
                                                )
                                                   return 1;
                                                return 0;
                                             } else if (options.kachelSort === "abc") {
                                                if (kachelA.heading < kachelB.heading) return -1;
                                                if (kachelA.heading > kachelB.heading) return 1;
                                                return 0;
                                             } else {
                                                return 0;
                                             }
                                          })
                                          .map((kachelData, index2) => {
                                             const kachelIndex = allKacheln[projektstufe].kachel.findIndex(
                                                (item) => item.kachelId === kachelData.kachelId,
                                             );
                                             return (
                                                <Kachel
                                                   editLayout={editLayout}
                                                   setEditLayout={setEditLayout}
                                                   kachelIndex={kachelIndex}
                                                   showAll={showAll}
                                                   setShowAll={setShowAll}
                                                   key={"kachel_" + projektstufe + "_" + index2}
                                                   kachelData={kachelData}
                                                   selectedkachel={selectedkachel}
                                                   data={basicdata}
                                                   projektstufe={projektstufe}
                                                   eskstatus={eskstatus}
                                                   loadSharepointData={loadSharepointData}
                                                   setEskStatus={setEskStatus}
                                                   changeEskStatus={changeEskStatus}
                                                   changeData={changeData}
                                                   estateId={estateId}
                                                   blockedField={blockedField}
                                                   sendData={sendData}
                                                   createOOTask={createOOTask}
                                                   currentElement={currentElement}
                                                   handleElementBlock={handleElementBlock}
                                                   teamsChannelNotification={teamsChannelNotification}
                                                   sendCommentsandNotes={sendCommentsandNotes}
                                                   fieldconfiguration={fieldconfiguration}
                                                   notizen={notizen}
                                                   sharepointIDs={sharepointIDs}
                                                   sharepointObject={sharepointObject}
                                                   loading={loading}
                                                   user={user}
                                                   userlist={userlist}
                                                   userObjects={userObjects}
                                                   kachelAbschliessen={kachelAbschliessen}
                                                   removeKachel={removeKachel}
                                                   allKacheln={allKacheln}
                                                   setAllKacheln={setAllKacheln}
                                                />
                                             );
                                          })}
                                    </Accordion>
                                 </>
                              )}

                              {projektstufe && allKacheln && (
                                 <TabMenu
                                    estatekacheln={allKacheln[projektstufe]?.kachel?.filter((kItem) => {
                                       return eskstatus["kachel_status_" + kItem.kachelId] >= 9;
                                    })}
                                    projektstufe={projektstufe}
                                    sendData={sendData}
                                    loading={loading}
                                    eskstatus={eskstatus}
                                 />
                              )}
                              {["globaladmin"].includes(user.role) && (
                                 <div className="flex-row">
                                    <AddKachel
                                       projektstufe={projektstufe}
                                       allKacheln={allKacheln}
                                       setAllKacheln={setAllKacheln}
                                       fieldconfiguration={fieldconfiguration}
                                    />

                                    <AddStufe
                                       projektstufe={projektstufe}
                                       allKacheln={allKacheln}
                                       setAllKacheln={setAllKacheln}
                                       fieldconfiguration={fieldconfiguration}
                                    />
                                 </div>
                              )}
                           </>
                        )}
                     </div>
                  )}
               </div>
            </>
         )}
      </div>
   );
}
